import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45c276e8")

_pushScopeId("data-v-45c276e8")
const _hoisted_1 = { class: "FTLOrderBasicCar" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "FTLOrderBasicCar__title" }, "Машина", -1)
const _hoisted_3 = { class: "FTLOrderBasicCar__body" }
const _hoisted_4 = { class: "body__block" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Грузоподъёмность", -1)
const _hoisted_6 = { class: "block__text" }
const _hoisted_7 = { class: "body__block" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Температурный режим", -1)
const _hoisted_9 = { class: "block__text" }
const _hoisted_10 = { class: "body__block" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Кубатура", -1)
const _hoisted_12 = { class: "block__text" }
const _hoisted_13 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Не указана")
const _hoisted_15 = { class: "body__block" }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Тип погрузки", -1)
const _hoisted_17 = { class: "block__text" }
const _hoisted_18 = { class: "body__block" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Негабарит", -1)
const _hoisted_20 = { class: "block__text" }
const _hoisted_21 = { class: "body__block" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "ФИО водителя и номер машины", -1)
const _hoisted_23 = { class: "block__text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("p", _hoisted_6, _toDisplayString(_ctx.FTLOrderState.data.load_capacity), 1)
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("p", _hoisted_9, _toDisplayString(_ctx.FTLOrderState.data.temperature_mode
                            ? _ctx.FTLOrderState.data.temperature_mode
                            : 'Не указан'), 1)
      ]),
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode("p", _hoisted_12, [
          (_ctx.FTLOrderState.data.cubature)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.FTLOrderState.data.cubature) + " м", 1),
                _hoisted_13
              ], 64))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _hoisted_14
              ], 64))
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode("p", _hoisted_17, _toDisplayString(_ctx.FTLOrderState.data.loading_type), 1)
      ]),
      _createVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode("p", _hoisted_20, _toDisplayString(_ctx.FTLOrderState.data.oversized_cargo), 1)
      ]),
      _createVNode("div", _hoisted_21, [
        _hoisted_22,
        _createVNode("p", _hoisted_23, _toDisplayString(_ctx.FTLOrderState.data.driver_name || 'Без имени') + " " + _toDisplayString(_ctx.FTLOrderState.data.car_number), 1)
      ])
    ])
  ]))
})